"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const NumberInput_1 = __importDefault(require("src/components/shared/NumberInput"));
const InputWeight = ({ objective, isAllowToUpdate, isLocked }) => {
    var _a;
    const [isRender, setRender] = (0, react_1.useState)(false);
    const handleChangeWeightInput = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.handleChangeWeightInput);
    const isPercentage = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.isPercentage);
    const onChangeInput = (value) => {
        if (isRender) {
            handleChangeWeightInput(objective === null || objective === void 0 ? void 0 : objective.id, parseFloat(value));
        }
        else {
            setRender(true);
        }
    };
    return (react_1.default.createElement(NumberInput_1.default, { className: `styled-input !m-[0px] ${isPercentage ? 'w-[80px]' : 'w-full'}`, inputClass: "m-[0px]", value: ((_a = objective === null || objective === void 0 ? void 0 : objective.weight) === null || _a === void 0 ? void 0 : _a.toString()) || 0, onChange: onChangeInput, max: 100, precision: 13, disabled: !isAllowToUpdate || (isPercentage ? false : isLocked), dataCy: "weight-percentage", htmlFor: `input-${objective === null || objective === void 0 ? void 0 : objective.id}`, ableToInputZero: true }));
};
exports.default = InputWeight;
